import React from 'react';

const SvgSc = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="SC_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="SC_svg__b">
        <stop stopColor="#1DBE4F" offset="0%" />
        <stop stopColor="#159B3F" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="SC_svg__c" fill="#fff">
        <use xlinkHref="#SC_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        d="M28 6.667L0 20l28-6.667V20H0V0h28v6.667z"
        fill="url(#SC_svg__b)"
        mask="url(#SC_svg__c)"
      />
      <path fill="#0858B4" mask="url(#SC_svg__c)" d="M0 0h9.333L0 20z" />
      <path
        fill="#ED3535"
        mask="url(#SC_svg__c)"
        d="M18.667 0H28v6.667L0 20z"
      />
      <path fill="#08964F" mask="url(#SC_svg__c)" d="M28 20v-6.667L0 20z" />
      <path fill="#FFDD67" mask="url(#SC_svg__c)" d="M9.333 0h9.334L0 20z" />
    </g>
  </svg>
);

export default SvgSc;
